import { useModal } from 'hooks/ui';

type HookArgs = {
  onSuccess: () => void;
  onAbort: () => void;
};

export const useLeaveAIAssistant = () => {
  const modal = useModal();

  return ({ onSuccess, onAbort }: HookArgs) =>
    modal.confirm({
      title: 'Close AI assistant',
      text: 'You are about to close AI assistant. All not saved data will disappear.',
      onSuccess,
      onAbort,
      successAction: 'Confirm',
      abortAction: 'Cancel',
    });
};
